module.exports = __webpack_public_path__ + "img/notice_库存预警.jpg";